import hook from '../../scripts/utilities/hook';

const HEADER_SELECTOR = hook('js-header');
const TRIGGER_SELECTOR = hook('js-header-trigger');
const MOBILE_THRESHOLD_VALUE = 1200;

const ACTIVE_CLASS = 'is-open';

class HEADER {
  constructor(element) {
    // early exist
    if (!element) {
      return;
    }
    this.element = element;

    this.initSelector();
    this.initListeners();
  }

  initSelector() {
    this.button = this.element.querySelector(TRIGGER_SELECTOR);
  }

  initListeners() {
    if (document.body.clientWidth < MOBILE_THRESHOLD_VALUE) {
      this.button.addEventListener('click', () => {
        this.toggleHeader();
      });
    }
  }

  toggleHeader() {
    if (this.element.classList.contains(ACTIVE_CLASS)) {
      this.element.classList.remove(ACTIVE_CLASS);
      document.removeEventListener('click', this.bindMyEvent);
    } else {
      this.element.classList.add(ACTIVE_CLASS);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(HEADER_SELECTOR).forEach(element => {
    // eslint-disable-next-line no-unused-vars
    const elementCard = new HEADER(element);
  });
});
